import React from "react";
import HereTechAutocomplete from "./HereTechAutoComplete";

export default function AutocompleteLocation({
  ...props
}) {
  return <HereTechAutocomplete {...props} />
}
